// Making a new JS component
// 1 - Replace filteredList with new name ( 8 occurences in this file )
// 2 - All code goes into init()
// 3 - Save file as new name .js
var filteredList = {
	name: 'filteredList',
	componentInitSelector: '.filtered-list:not(.filtered-list--v2)',
	registerComponent: function() {
		if ( $(filteredList.componentInitSelector).length ) {
			framework.registerComponent(filteredList);
		}
	},
	initfilteredList: function() {
        // Put your args and inits here with their options.

        // End
        log(config.application.name + " •• filteredList in " + Math.round( performance.now() - framework.initComponents.componentInitTime) + " milliseconds" );
    },
	init: function() {
		// All code for this component goes in here
		var initShow = 21; //number of items loaded on init & onclick load more button
		var counter = initShow; 
		var qsRegex;
		var filters = [];

		// init Isotope
		var $grid = $('.grid').isotope({
			itemSelector: '.filteredItem',
			filter: function() {
				if (!qsRegex && (filters.length == 0 || filters[0] == '*')) {
					return true;
				}

				var valid = false;
				if (qsRegex) {
					valid = qsRegex.test($(this).text());
					if (!valid) {
						return false;
					}
				}

				if (filters.length > 0 && filters[0] != '*') {
					valid = false;
					var $elem = $(this);

					$.each(filters, function(index, value) {
						if ($elem.is(value)) {
							valid = true;
							return false;
						}
					});
				}

				return valid;
			}
		});

		var $quicksearch = $('.quicksearch').keyup( debounce( function() {
			var value = $quicksearch.val();
			if (value) {
				qsRegex = new RegExp(value, 'gi' );
			} else {
				qsRegex = null;
			}

	   $quicksearch.keypress(function(e) {
	        if(e.which == 13) {
				$(window).scrollTo('#post-content', {duration:800});
				document.activeElement.blur();
				$("input").blur();
	        }
	    });

			$grid.find(".hidden").removeClass("hidden");
			$grid.isotope();
			loadMore(initShow);
		}, 200 ) );


		function debounce( fn, threshold ) {
			var timeout;
			threshold = threshold || 100;
			return function debounced() {
				clearTimeout( timeout );
				var args = arguments;
				var _this = this;
				function delayed() {
					fn.apply( _this, args );
				}
				timeout = setTimeout( delayed, threshold );
			};
		}

		var iso = $grid.data('isotope');

		function loadMore(toShow) {
			$grid.find(".hidden").removeClass("hidden");

			var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function(item) {
				return item.element;
			});
			
			$(hiddenElems).addClass('hidden');
			

			//when no more to load, hide show more button
			if (hiddenElems.length == 0) {
				$(".load-more").hide();
			} else {
				$(".load-more").show();
			};

			$grid.isotope('layout');
		}

		loadMore(initShow);

		//when load more button clicked
		$(".load-more").click(function() {
			if ( filters.length > 0 ) {
				//when filter button clicked, set initial value for counter
				counter = initShow;
				$('#filters').data('clicked', false);
			} else {
				counter = counter;
			};

			counter = counter + initShow;

			loadMore(counter);
		});


		// store filter for each group
		$('.filtered-list .filters').on( 'click', '.filter', function( event ) {
			event.preventDefault();
			log(config.application.name + " •• filteredList filter event");
			var $target = $( event.currentTarget );
			$target.toggleClass('is-active');
			var isActive = $target.hasClass('is-active');
			var filter = $target.attr('data-filter');	

			// Here i check if its active you silly goose....
			if ( isActive ) {
				addFilter( filter );
				$('.filterButton').addClass('is-active');
			} else {
				removeFilter( filter );
			}

			log(config.application.name + " •• filteredList filters are: ", filters);
			// filter isotope
			$grid.find(".hidden").removeClass("hidden");
			$grid.isotope();
			loadMore(initShow);
		});
		  
		function addFilter( filter ) {
			if ( filters.indexOf( filter ) == -1 ) {
				filters.push( filter );
			}
		}

		function removeFilter( filter ) {
			var index = filters.indexOf( filter);
			if ( index != -1 ) {
				filters.splice( index, 1 );
			}
		}

		$('.filtered-list').on('click', '.tabButton', function(event) {
			event.preventDefault();

			//console.log("event", event);


			$('.filtered-list .tabButton.is-active').removeClass('is-active');
			$(this).addClass('is-active');
			var $filteredList = $(this).parents('.filtered-list');
			if (!$filteredList.data('scrolled'))
			{
				$(window).one().animate({scrollTop: '+=200px', });
				$filteredList.data('scrolled', true);
			}

			if ( $(this).index() === 0 ) {
				//all
				$('.sector-list').removeClass('is-active');
				$('.type-list').removeClass('is-active');
				$('.location-list').removeClass('is-active');
				$('.region-list').removeClass('is-active');
				filters = [];
				filters.push('*');
				$('.filtered-list .filters .filter.is-active').removeClass('is-active')
				$grid.isotope();
			} else if( $(this).index() === 1 ) {
				$('.sector-list').addClass('is-active');
				$('.type-list').removeClass('is-active');
				$('.location-list').removeClass('is-active');
				$('.region-list').removeClass('is-active');
				removeFilter( '*' );
			} else if( $(this).index() === 2 ) {
				$('.type-list').addClass('is-active');
				$('.sector-list').removeClass('is-active');
				$('.location-list').removeClass('is-active');
				$('.region-list').removeClass('is-active');
				removeFilter( '*' );
			} else if( $(this).index() === 3 ) {
				$('.location-list').addClass('is-active');
				$('.sector-list').removeClass('is-active');
				$('.region-list').removeClass('is-active');
				$('.type-list').removeClass('is-active');
				removeFilter( '*' );
			} else {
				$('.region-list').addClass('is-active');
				$('.sector-list').removeClass('is-active');
				$('.location-list').removeClass('is-active');
				$('.type-list').removeClass('is-active');
				removeFilter( '*' );
			}
		})

		// View All Jobs Button
			$('.view-all.button').click(function() {
			event.preventDefault();
			$('.filtered-list .tabButton.is-active').removeClass('is-active');
			$('.filtered-list .tabButton:first-child').addClass('is-active');
            $('.job-location-title').fadeOut(0);
            $('.view-all.button').fadeOut(0);
			var $filteredList = $(this).parents('.filtered-list');

			$('.sector-list').removeClass('is-active');
			$('.type-list').removeClass('is-active');
			$('.location-list').removeClass('is-active');
			$('.region-list').removeClass('is-active');
			filters = [];
			filters.push('*');
			$grid.isotope();

		})

		$('[data-filter="*"]').click(function(){
			$('.job-location-title, .view-all.button').hide();
		});
		
		// Auto filter country
		var pageLocation = window.location.href;
		pageLocation = pageLocation.replace(/\//g,"");
		// var lastPart = url.substr(url.lastIndexOf('/') + 1);

        if (pageLocation.match("from=fr")) {
            $('.filterToggles .tabButton:first-child').removeClass('is-active');
			$('*[data-filter=".paris-france"]').click();
            $('.job-location-title').append('France');
        } else if (pageLocation.match("from=us")) {
            $('.filterToggles .tabButton:first-child').removeClass('is-active');
            $('.filterToggles .tabButton:nth-child(5)').addClass('is-active');
            $('*[data-filter=".us"]').click();
            $('.job-location-title').append('United States');
        } else if (pageLocation.match("from=uk")) {
            $('.filterToggles .tabButton:first-child').removeClass('is-active');
            $('*[data-filter=".uk"]').click();
            $('.job-location-title').append('United Kingdom');
        } else if (pageLocation.match("from=nl")) {
            $('.filterToggles .tabButton:first-child').removeClass('is-active');
			$('*[data-filter=".amsterdam-netherlands"]').click();
            $('*[data-filter=".eindhoven-netherlands"]').click();
            $('.job-location-title').append('Netherlands'); 
        } else if (pageLocation.match("from=de")) {
            $('.filterToggles .tabButton:first-child').removeClass('is-active');
			$('*[data-filter=".dusseldorf-germany"]').click();
            $('*[data-filter=".frankfurt-germany"]').click();
            $('*[data-filter=".munich-germany"]').click();
            $('.job-location-title').append('Germany'); 
        } else if (pageLocation.match("from=it")) {
            $('.filterToggles .tabButton:first-child').removeClass('is-active');
			$('*[data-filter=".milan-italy"]').click();
            $('.job-location-title').append('Italy'); 
        } else if (pageLocation.match("from=be-fr")) {
            $('.filterToggles .tabButton:first-child').removeClass('is-active');
			$('*[data-filter=".antwerp-belgium"]').click();
            $('.job-location-title').append('Belgium'); 
        } else if (pageLocation.match("from=be-nl")) {
            $('.filterToggles .tabButton:first-child').removeClass('is-active');
			$('*[data-filter=".antwerp-belgium"]').click();
            $('.job-location-title').append('Belgium'); 
        } else if (pageLocation.match("from=asia")) {
            $('.filterToggles .tabButton:first-child').removeClass('is-active');
			$('*[data-filter=".guangzhou-china"]').click();
			$('*[data-filter=".shanghai-china"]').click();
			$('*[data-filter=".kuala-lumpur-malaysia"]').click();
			$('*[data-filter=".singapore-singapore"]').click();
            $('.job-location-title').append('Asia'); 
        } else if (pageLocation.match("from=pt")) {
            $('.filterToggles .tabButton:first-child').removeClass('is-active');
			$('*[data-filter=".lisbon-portugal"]').click();
            $('.job-location-title').append('Portugal'); 
		} 

		// End
		filteredList.initfilteredList();

	}
}

// Register self to the framework
filteredList.registerComponent();